import { RemsReconciliationPage as RemsReconciliation } from "./RemsReconciliationSection";

export function RemsReconciliationPage(props: React.ComponentProps<typeof RemsReconciliation>): React.ReactNode {
  return <RemsReconciliation {...props} />;
}
